import React, { memo } from "react";
import { BaseEdge, getSmoothStepPath } from "reactflow";

const DottedSmoothStepEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = { strokeDashArray: "5 5" },
  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const updatedStyle = {
    ...style,
    strokeDasharray: "5, 5",
  };

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={updatedStyle}
      />
    </>
  );
};

export default memo(DottedSmoothStepEdge);
